<template>
  <div class="footer">
    <div class="footer__links">
      <b-container>
        <b-row no-gutters>
          <b-col>
            <links></links>
          </b-col>
        </b-row>
      </b-container>
      <links-nav v-show="!screenMdPlus"></links-nav>
    </div>
    <div v-show="screenLgPlus" class="footer__media-press">
      <b-container>
        <b-row>
          <b-col>
            <media-press></media-press>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div v-show="!screenLgPlus" class="footer__payment-methods">
      <b-container>
        <b-row no-gutters class="align-items-center">
          <b-col>
            <payment-methods></payment-methods>
          </b-col>
          <b-col v-show="screenMdPlus">
            <social-links></social-links>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div v-show="!screenMdPlus" class="footer__social-links">
      <b-container>
        <b-row no-gutters>
          <b-col>
            <social-links></social-links>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="footer__bottom-bar">
      <b-container>
        <b-row no-gutters>
          <b-col>
            <bottom-bar></bottom-bar>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<style lang="sass" scoped>

  @import '~/assets/stylesheets/utils/module.sass'

  .footer__contact-us
    background-color: $primary-pure

  .footer__links, .footer__media-press
    background-color: $footer-bg

  .footer__links
    box-shadow: inset $box-shadow

  .footer__media-press
    padding-top: $space-s

    &:before
      border-top: 1px solid $footer-color
      content: ' '
      display: block
      opacity: 0.43

  .footer__bottom-bar, .footer__payment-methods, .footer__social-links
    background-color: $bottombar-bg

  .footer__payment-methods, .footer__social-links
    border-bottom: 1px solid $footer-color

</style>

<script>
  import BottomBar from '~/components/footer/bottom-bar';
  import Links from '~/components/footer/links';
  import LinksNav from '~/components/footer/links-nav';
  import MediaPress from '~/components/footer/media-press';
  import PaymentMethods from '~/components/footer/payment-methods';
  import SocialLinks from '~/components/footer/social-links';

  export default {
    data() {
      return {}
    },
    components: {
      Links,
      LinksNav,
      BottomBar,
      PaymentMethods,
      SocialLinks,
      MediaPress,
    },
    computed: {
      screenLgPlus() {
        return (this.$mq === 'lg' || this.$mq === 'xl');
      },
      screenMdPlus() {
        return (this.$mq === 'md' || this.screenLgPlus);
      },
    }
  }
</script>
